
import { defineComponent, ref, Ref, onMounted } from 'vue';

import store from '@/store';

export default defineComponent({
	setup() {
		const mdEditor: Ref<HTMLTextAreaElement | null> = ref(null);

		onMounted(() => {
			mdEditor.value?.addEventListener('scroll', () => {
				if (!mdEditor.value) return;
				const mdPreview = document.getElementById('mdPreview');
				if (mdPreview) mdPreview.scrollTop = mdEditor.value.scrollTop;
			});
		});

		function textAreaHandler(e: KeyboardEvent) {
			if (!mdEditor.value) return;
			let contentArr = [...mdEditor.value.value];
			const delimiters: any = {
				//let's me use [] without writing a type
				always: {
					'"': '"',
					'(': ')',
					'{': '}',
					'[': ']',
					'<': '>',
					'`': '`',
				},
				nextToWhitespace: {
					"'": "'",
					_: '_',
					'*': '*',
					'~': '~',
				},
			};

			const ctrlChars: any = {
				b: '**',
				i: '_',
			};

			const cursorStart = mdEditor.value.selectionStart;
			const cursorEnd = mdEditor.value.selectionEnd;

			// handle selection delimiters
			if (cursorStart !== cursorEnd) {
				if (e.key === 'Backspace') return;

				if (e.ctrlKey) {
					if (!(e.key in ctrlChars)) return;

					e.preventDefault();
					contentArr.splice(cursorStart, 0, ctrlChars[e.key]);
					contentArr.splice(cursorEnd + 1, 0, ctrlChars[e.key]);
					mdEditor.value.value = contentArr.join('');
					mdEditor.value.selectionStart = cursorStart;
					mdEditor.value.selectionEnd = cursorEnd + ctrlChars[e.key].length * 2;
					return;
				}

				if (!(e.key in delimiters.always || e.key in delimiters.nextToWhitespace)) return;
				e.preventDefault();
				const delimiter1 = delimiters.always[e.key] || delimiters.nextToWhitespace[e.key];

				contentArr.splice(cursorStart, 0, e.key);
				contentArr.splice(cursorEnd + 1, 0, delimiter1);
				mdEditor.value.value = contentArr.join('');

				mdEditor.value.selectionStart = cursorStart;
				mdEditor.value.selectionEnd = cursorEnd + 2;

				return;
			}

			// handle regular delimiters
			if (e.key === 'Backspace') {
				if (
					!(
						(contentArr[cursorStart] in delimiters.always || contentArr[cursorStart] in delimiters.nextToWhitespace) &&
						(contentArr[cursorStart - 1] in delimiters.always || contentArr[cursorStart - 1] in delimiters.nextToWhitespace)
					)
				)
					return;
				contentArr.splice(cursorStart, 1);
			} else if (e.ctrlKey) {
				if (!(e.key in ctrlChars)) return;
				e.preventDefault();
				contentArr.splice(cursorStart, 0, ctrlChars[e.key] + ctrlChars[e.key]);
				mdEditor.value.value = contentArr.join('');
				mdEditor.value.selectionStart = cursorStart + ctrlChars[e.key].length;
				mdEditor.value.selectionEnd = cursorStart + ctrlChars[e.key].length;
				return;
			} else if (e.key in delimiters.always) {
				contentArr.splice(cursorStart, 0, delimiters.always[e.key]);
			} else if (e.key in delimiters.nextToWhitespace) {
				if (/^\S$/g.test(contentArr[cursorStart - 1])) return;
				contentArr.splice(cursorStart, 0, delimiters.nextToWhitespace[e.key]);
			} else return;

			mdEditor.value.value = contentArr.join('');
			mdEditor.value.selectionEnd = cursorStart;
			mdEditor.value.selectionStart = cursorStart;
		}

		return {
			store,
			mdEditor,
			textAreaHandler,
		};
	},
});
